export default {
  loggedIn() { return !!localStorage.getItem("token") },
  logIn(user, token) {
    localStorage.setItem("storageUser", JSON.stringify(user))
    localStorage.setItem("token", token)
  },
  logOut() {
    localStorage.removeItem("storageUser")
    localStorage.removeItem("token")
  },
  getUser() {
    const u = localStorage.getItem("storageUser")
    return u ? JSON.parse(u) : null
  }
}
